import React from "react";
import { Box, Typography } from "@mui/material";
import "./LoanTypesDetailsView.scss";

const formatLabel = (key) => {
    return key
      .replace(/([A-Z])/g, " $1") // Inserts a space before every uppercase letter
      .replace(/_/g, " ") // Replaces underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalizes the first letter of each word
};

const yesNoFields = [
    "ignoreholidays",
    "flagging",
    "optout",
    "optin",
    "includefeesineligibilitycheck",
    "restrictive",
    "ignorenextbusinessday",
    "selectablebyuser",
    "isflaggedloandue",
    "displayorderno"
];

const renderSection = (title, data = {}, extraFields = [], hasStructuredData, handleLangIdSelect) => {
    console.log("renderSection========",title);
    let entries = Object.entries(data);
    entries = entries.filter(([key, value]) => key !== "structuredData");

    if (extraFields.length > 0) {
        // Merge extra fields
        entries = [...entries, ...extraFields];
    }

    if (entries.length === 0) return null;

    const half = Math.ceil(entries.length / 2);
    const left = entries.slice(0, half);
    const right = entries.slice(half);

    return (
        <Box sx={{ mb: 4 }}>
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: "16px",
                    color: "#4B5563",
                    fontFamily: "Nunito",
                    mb: 2,
                    borderBottom: "2px solid #E5E7EB",
                    pb: 1,
                }}
            >
                {title}
            </Typography>

            <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                {[left, right].map((column, index) => (
                    <Box key={index} flex={1}>
                        {column.map(([key, value]) => {
                            const formattedValue = yesNoFields.includes(key.toLowerCase())
                                ? value?.toString() === "1" ? "Yes" : "No"
                                : value?.toString() || "N/A";

                            return (
                                <Box key={key} className="info-container">
                                    <Box className="info-type">{formatLabel(key)}:</Box>
                                    {
                                        hasStructuredData == false ? 
                                        <Box className="info-response msg-text-ids" onClick={() => handleLangIdSelect(formattedValue)}>
                                            {formattedValue}
                                        </Box> :
                                        <Box className="info-response">{formattedValue}</Box>
                                    }
                                    {/* <Box className="info-response">{formattedValue}</Box> */}
                                </Box>
                            );
                        })}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

const LoanTypesDetailsView = ({ title = "Info", data = {}, handleLangIdSelect }) => {
console.log("LoanTypesDetailsView_data================", data);
    const extraFields = [];

    // const hasStructuredData = (data?.lt || data?.pft1 || data?.lp || data?.pft2) || false;
    // const hasStructuredData = (typeof(data?.LateFeeTableId) == "string") || false;
    // const hasStructuredData = (data?.lt || data?.pft1 || data?.lp || data?.pft2 ||  typeof(data?.LateFeeTableId) == "string") ? true : false;
    const hasStructuredData = (data?.lt || data?.pft1 || data?.lp || data?.pft2 || typeof(data?.LateFeeTableId) == "string") ? true : false;
    console.log("LoanTypesDetailsView_hhhhhasStructuredData================", hasStructuredData);

    if (data?.lt) {
        // Fee Calculation Mode
        const feeCalcMode = data.lt.feecalculationmode?.toString();
        if (feeCalcMode === "1") {
            extraFields.push(["Fee Calculation Mode", "Original Principal"]);
        } else if (feeCalcMode === "2") {
            extraFields.push(["Fee Calculation Mode", "Outstanding Principal"]);
        } else if (feeCalcMode === "3") {
            extraFields.push(["Fee Calculation Mode", "Total Outstanding"]);
        }

        // Disbursement Type
        const disbursementType = data.lt.disbursementtype?.toString();
        if (disbursementType === "1") {
            extraFields.push(["Disbursement Type", "Full Principal"]);
        } else if (disbursementType === "2") {
            extraFields.push(["Disbursement Type", "Principal minus Interest"]);
        }

        // Term Interest Allocation Type
        const termInterestAllocationType = data.lt.terminterestallocationtype?.toString();
        if (termInterestAllocationType === "0") {
            extraFields.push(["Term Interest Allocation Type", "Diminishing Allocation"]);
        } else if (termInterestAllocationType === "1") {
            extraFields.push(["Term Interest Allocation Type", "Flat Allocation"]);
        }
    }

    return (
        <Box className="user-accounts-tab">
            <Typography
                sx={{
                    fontWeight: 800,
                    color: "#6b7280",
                    fontFamily: "Nunito",
                    fontSize: "20px",
                    fontStyle: "normal",
                    mb: 3,
                }}
            >
                {title}
            </Typography>

            {/* Sections */}
            {renderSection("Details", data, [], hasStructuredData, handleLangIdSelect)}
            {/* {hasStructuredData ? (
                <>
                    {renderSection("Loan Type Info", data?.lt, extraFields)}
                    {renderSection("Purchase Table Info", data?.pft1)}
                    {renderSection("Product Info", data?.lp)}
                    {renderSection("Late Fee Table Info", data?.pft2)}
                </>
            ) : (
                renderSection("Details", data, [], hasStructuredData, handleLangIdSelect)
            )} */}
        </Box>
    );
};

export default LoanTypesDetailsView;